import React from 'react';

/** Lightweight decorative accents; deliberately avoids expensive blur filters. */
export function Splashes({
  className = ''
}: {
  className?: string;
}) {
  return <div aria-hidden="true" className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} data-id="element-257" data-mp="2x6cd08fb57st">
      <span className="absolute -left-16 top-12 h-36 w-36 rounded-full border border-magenta/30 bg-magenta/10" data-id="element-258" data-mp="2neptlostg2ez" />
      <span className="absolute right-8 top-1/4 h-24 w-24 rounded-full border border-lime/25 bg-lime/[0.06]" data-id="element-259" data-mp="3b3sinhps4xji" />
      <span className="absolute bottom-8 left-1/3 h-16 w-16 rounded-full border border-aqua/20" data-id="element-260" data-mp="3g3nabnhdpr5m" />
    </div>;
}